import star from 'assets/images/smStar.svg'
import tableimg from 'assets/images/TableImg.svg';
import feedbackStar from 'assets/images/Star.svg';

export const feedbackData =
{
  header: [
    {
      label: 'Trip ID',
      key: 'id',
      width: '2rem',
      padding: '6px 17px 6px 4px',
    },

    {
      label: 'Name',
      key: 'name',
      width: '1.5rem',
      color: '#fff',
      padding: '6px 6px 6px 4px',
    },
    {
      label: 'location',
      key: 'location',
      width: '1.9rem',
      headerAlign: 'right',
      align: 'right',
      padding: '6px 17px 6px 4px',
    },
    {
      label: 'Rating',
      key: 'rating',
    },
    {
      label: 'Comment',
      key: 'comment',
    },
  ],
  body: [
    {
      id: '1',
      image: tableimg,
      name: 'Rahul Kumar',
      location: 'Bangalore',
      rating: '4',
      ratingmsg: 'Excellent Friendly Very Good ',
      star: star,
      comment: 'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
    },
    {
      id: '2',
      image: tableimg,
      name: 'Rahul Kumar',
      location: 'Bangalore',
      rating: '4',
      ratingmsg: 'Excellent Friendly Good ',
      star: star,
      comment: 'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
    },
  ],
}

export const feedback =    [
  {
    id: 1,
    primaryText: 'Feedback',
    star: true,
    subItems: [
      { label: '5', value: '5'},
      { label: '4', value: '4'},
      { label: '3', value: '3'},
      { label: '2', value: '2'},
      { label: '1', value: '1'},
    ]
  }
]

export const feedbackHead = (details) => [
  {
      id:'1',
      image: feedbackStar,
      ratingName: '5 Rating',
      totalrating: details?.ratingCount?.starFive || '0',
      rating:5
  },
  {
      id:'2',
      image: feedbackStar,
      ratingName: '4 Rating',
      totalrating: details?.ratingCount?.starFour || '0',
      rating:4
  },
  {
      id:'3',
      image: feedbackStar,
      ratingName: '3 Rating',
      totalrating: details?.ratingCount?.starThree || '0',
      rating:3
  },
  {
      id:'4',
      image: feedbackStar,
      ratingName: '2 Rating',
      totalrating: details?.ratingCount?.starTwo || '0',
      rating:2
  },
  {
      id:'5',
      image: feedbackStar,
      ratingName: '1 Rating',
      totalrating: details?.ratingCount?.starOne || '0',
      rating:1
  },
]
